var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"preview",on:{"click":_vm.onClick}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],staticClass:"fullscreen-image"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }